import React, { useContext, useState } from 'react';
import { OnboardingSummaryContext } from 'src/context/onboarding-summary-context';
import { formatCurrencyAmount } from 'src/helpers/formatting';
import { AcquiringChannelFlags, CustomerTypes } from 'src/context/salesforce-context';
import { isVirtualorInstoreDevice } from 'src/helpers/devices';
import './application-summary.scss';

export default function ApplicationSummary(props) {
  const {
    totalPrice,
    getDeliveriesToDisplay,
    onceOffCost,
    vatPercentage,
    customerType,
    hasBuyInstoreMixture,
    instoreDeviceName,
  } = useContext(OnboardingSummaryContext);
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      {props.tablet ? (
        <div className="ApplicationSummary button-bar-amount-total">
          <div className="ApplicationSummary button-bar-amount-total-upper">
            <p
              className="sub-heading"
              onClick={() => {
                setExpanded(!expanded);
              }}
            >
              Application Summary
              <span
                className={`button is-pulled-right chevron ${expanded ? 'expanded' : ''}`}
                automationid="Onboarding_Create_Account_Confirm_Delivery_Addresses_Span_Edit_Navigate_To_Your_Business"
              />
            </p>
            <div className={`fullwidth has-padding-bottom-4 ${expanded ? '' : 'is-hidden'}`}>
              <table className={`fullwidth `}>
                <tbody>
                  {getDeliveriesToDisplay()
                    .filter(
                      (terminal) => !terminal.product_category || !!terminal.is_product_category,
                    )
                    .map((delivery, index) => (
                      <tr key={index}>
                        <th className="autowidth has-padding-left-3 has-padding-top-4">
                          {delivery.device_name}
                        </th>
                        {props.showPrice &&
                        !isVirtualorInstoreDevice(delivery.acquiring_channel) ? (
                          <td className="has-text-right autowidth has-padding-right-3 has-padding-top-4">
                            {`R 
                            ${formatCurrencyAmount(
                              delivery.number_of_devices * (delivery.price || 0) +
                                delivery.number_of_devices * (delivery.price || 0) * vatPercentage,
                            )}
                            ${
                              delivery.acquiring_channel ===
                              AcquiringChannelFlags.buyOnlineFicaOnline
                                ? '/ once off'
                                : '/ month'
                            }`}
                          </td>
                        ) : (
                          <td className="has-text-right autowidth has-padding-right-3 has-padding-top-4">
                            {customerType === CustomerTypes.agent &&
                            delivery.acquiring_channel !== AcquiringChannelFlags.vodapay
                              ? 'Pay in store'
                              : `x ${delivery.number_of_devices}`}
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="ApplicationSummary button-bar-amount-total-below">
            <div className="table-div">
              {props.showPrice && (
                <table className="fullwidth">
                  <tbody>
                    <tr>
                      <th className="total-amount-label autowidth has-padding-left-3 has-padding-top-6">
                        Total monthly rental
                      </th>
                      <td className="total-amount has-text-right autowidth has-padding-right-3 has-padding-top-6">
                        {'R ' + formatCurrencyAmount(totalPrice)}
                        <div className="vat-detail">VAT Incl.</div>
                      </td>
                    </tr>
                    {onceOffCost > 0 && (
                      <tr>
                        <th className="total-amount-label autowidth has-padding-left-3 has-padding-top-3">
                          Total due now
                          <p className="light-text">
                            Funds will be reserved and only charged once your FICA is approved.
                          </p>
                        </th>
                        <td className="total-amount has-text-right autowidth has-padding-right-3 has-padding-top-3">
                          {'R ' + formatCurrencyAmount(onceOffCost)}
                          <div className="vat-detail">VAT Incl.</div>
                        </td>
                      </tr>
                    )}
                    {hasBuyInstoreMixture && (
                      <tr>
                        <th className="total-amount-label autowidth has-padding-left-3 has-padding-top-3">
                          {instoreDeviceName}
                        </th>
                        <td className="pay-instore has-text-right autowidth has-padding-right-3 has-padding-top-3">
                          Pay in store
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="ApplicationSummary button-bar-amount-total">
          <div className="ApplicationSummary button-bar-amount-total-upper">
            <p className="sub-heading">Application summary</p>
            <div className={`fullwidth has-padding-bottom-2`}>
              <table className="fullwidth">
                <tbody>
                  {getDeliveriesToDisplay()
                    .filter(
                      (terminal) => !terminal.product_category || !!terminal.is_product_category,
                    )
                    .map((delivery, index) => (
                      <tr key={index}>
                        <th className="autowidth has-padding-left-3 has-padding-top-4">
                          {delivery.device_name}
                        </th>
                        {props.showPrice &&
                        !isVirtualorInstoreDevice(delivery.acquiring_channel) ? (
                          <td className="has-text-right autowidth has-padding-right-3 has-padding-top-4">
                            {`R 
                            ${formatCurrencyAmount(
                              delivery.number_of_devices * (delivery.price || 0) +
                                delivery.number_of_devices * (delivery.price || 0) * vatPercentage,
                            )} 
                            ${
                              delivery.acquiring_channel ===
                              AcquiringChannelFlags.buyOnlineFicaOnline
                                ? '/ once off'
                                : '/ month'
                            }`}
                          </td>
                        ) : (
                          <td className="has-text-right autowidth has-padding-right-3 has-padding-top-4">
                            {customerType === CustomerTypes.agent &&
                            delivery.acquiring_channel !== AcquiringChannelFlags.vodapay
                              ? 'Pay in store'
                              : `x ${delivery.number_of_devices}`}
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="ApplicationSummary button-bar-amount-total-below">
            <div className="table-div">
              {props.showPrice && (
                <>
                  <table className="fullwidth">
                    <tbody>
                      <tr>
                        <th className="total-amount-label autowidth has-padding-left-3 has-padding-top-6">
                          Total monthly rental
                        </th>
                        <td className="total-amount has-text-right autowidth has-padding-right-3 has-padding-top-6">
                          {'R ' + formatCurrencyAmount(totalPrice)}
                          <div className="vat-detail">VAT Incl.</div>
                        </td>
                      </tr>
                      {onceOffCost > 0 && (
                        <tr>
                          <th className="autowidth has-padding-left-3 has-padding-top-3">
                            Total due now
                            <p className="light-text">
                              Funds will be reserved and only charged once your FICA is approved.
                            </p>
                          </th>
                          <td className="total-amount has-text-right autowidth has-padding-right-3 has-padding-top-3">
                            {'R ' + formatCurrencyAmount(onceOffCost)}
                            <div className="vat-detail">VAT Incl.</div>
                          </td>
                        </tr>
                      )}
                      {hasBuyInstoreMixture && (
                        <tr>
                          <th className="total-amount-label autowidth has-padding-left-3 has-padding-top-3">
                            {instoreDeviceName}
                          </th>
                          <td className="pay-instore has-text-right autowidth has-padding-right-3 has-padding-top-3">
                            Pay in store
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
